import { Component, OnInit } from '@angular/core';
import { BillingInvoiceEntityService } from '../../../services/billing/billing-invoice/billing-invoice-entity.service';
import { MenuService } from '../../../services/menu.service';
import { ActivatedRoute } from '@angular/router';
import { BillingInvoiceEditService } from 'src/app/services/billing/billing-invoice/billing-invoice-edit.service';
import { BillingInvoiceEntityEditService } from 'src/app/services/billing/billing-invoice/billing-invoice-entity-edit.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-billing-invoice-entity-edit',
  templateUrl: './billing-invoice-entity-edit.component.html',
  styleUrls: ['./billing-invoice-entity-edit.component.css'],
  providers: [{ provide: BillingInvoiceEditService, useClass: BillingInvoiceEntityEditService }]
})
export class BillingInvoiceEntityEditComponent implements OnInit {

  loading: boolean;
  id: number;
  invoiceTypeId: number;

  constructor( private menuService: MenuService,
               private billingInvoiceEditService: BillingInvoiceEditService,
               private authService: AuthService,
               private route: ActivatedRoute ) {
    this.menuService.setMenuTitle('Factura', 'Entidad');
  }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async params => {
      this.id = +params['Id'];
      this.invoiceTypeId = +params['Type'];
      this.billingInvoiceEditService.setBillingInvoiceParams(
        this.authService.getSectorId(),
        this.id,
        this.invoiceTypeId);
      this.loading = false;
    });
  }
}
